<template>
  <div class="panel-header panel-header-lg">
    <div class="header-text text-center text-white" style="margin-top: -4rem">
      <div class="d-flex justify-content-center align-items-center">
        <h3 class="pb-0 mb-0 d-inline">Suivi du nombre de commandes livrées en</h3>

        <!-- Sélecteur d'année inline avec ajustements -->
        <select v-model="selectedYear" @change="fetchChartData"
                class="form-control form-control-sm d-inline-block w-auto ml-2"
                style="background: whitesmoke; z-index: 999999; position: relative;">
          <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
        </select>
      </div>
    </div>

    <header-chart :height="255"
                  :data="chartData"
                  :labels="chartLabels"
                  :halloween="halloweenEnabled"
                  :key="key">
    </header-chart>
  </div>
</template>

<script>
import HeaderChart from './HeaderChart';

export default {
  name: 'overview-header',
  components: {
    HeaderChart
  },
  data() {
    const currentYear = new Date().getFullYear(); // Récupère l'année courante

    return {
      key: 0,
      selectedYear: currentYear, // L'année sélectionnée, par défaut l'année courante
      halloweenEnabled: window.localStorage.getItem('process-halloween-theme') !== 'off',
      chartData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Données du graphique
      chartLabels: [
        'JAN', 'FEV', 'MAR', 'AVR', 'MAI', 'JUI', 'JUI', 'AOU', 'SEP', 'OCT', 'NOV', 'DEC'
      ],
      availableYears: this.generateYearsList(currentYear), // Liste des années disponibles
    };
  },
  methods: {
    onHalloweenThemeChange(event) {
      this.halloweenEnabled = event.detail;
      this.key++;
    },
    // Génère une liste d'années (disons depuis 2015 jusqu'à l'année courante)
    generateYearsList(currentYear) {
      const startYear = 2015; // Par exemple, les données commencent en 2015
      const years = [];
      for (let year = currentYear; year >= startYear; year--) {
        years.push(year);
      }
      return years;
    },

    // Méthode pour récupérer les données du graphique pour une année donnée
    fetchChartData() {
      this.axios.get(`${process.env.VUE_APP_API_BASE_URL}dashboard/headerchart`, {
        params: { year: this.selectedYear } // Passer l'année sélectionnée en paramètre
      }).then((response) => {
        this.chartData = response.data;
        this.key++; // Pour forcer la mise à jour du graphique
      }).catch((error) => {
        // Gérer les erreurs
        console.error("Erreur lors du chargement des données du graphique :", error);
      });
    }
  },
  mounted() {
    window.addEventListener('process-halloween-theme-change', this.onHalloweenThemeChange);
    // Charger les données par défaut pour l'année courante
    this.fetchChartData();
  },
  beforeDestroy() {
    window.removeEventListener('process-halloween-theme-change', this.onHalloweenThemeChange);
  },
};
</script>


<style>
.year-selector {
  margin-right: 1rem; /* Optionnel : ajuster l'espacement du sélecteur à droite */
}
</style>
